import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, requireRole = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  const passedUser = location.state?.user;
  if (loading && !passedUser) {
    return (
      <div className="grid min-h-screen place-items-center bg-ink" data-testid="auth-loading">
        <Loader2 size={22} className="animate-spin text-aqua" />
      </div>
    );
  }
  const effectiveUser = passedUser || user;
  if (!effectiveUser) return <Navigate to="/login" replace />;
  if (adminOnly && effectiveUser.role !== "admin") return <Navigate to="/account" replace />;
  if (requireRole === "partner" && effectiveUser.role !== "partner") {
    return <Navigate to={effectiveUser.role === "admin" ? "/admin" : "/account"} replace />;
  }
  return children;
};
